import PlotImport, { PlotParams } from "react-plotly.js";
import type { Layout, Config } from "plotly.js";
import { applyPlotlyDefaults } from "./plotlyDefaults";

// Handle ESM/CJS interop - Plot might be { default: Plot } in production builds
const Plot =
  typeof PlotImport === "function"
    ? PlotImport
    : (PlotImport as unknown as { default: typeof PlotImport }).default;

const Plotly = ({ jsonData }: { jsonData: PlotParams }) => {
  const normalized = applyPlotlyDefaults(jsonData as PlotParams);
  const plotLayout = (normalized.layout || {}) as Partial<Layout>;
  const plotConfig = (normalized.config || {}) as Partial<Config>;
  return (
    <div style={{ width: "100%", height: "400px" }} aria-label="Plotly chart">
      <Plot
        data={normalized.data}
        layout={plotLayout}
        useResizeHandler={true}
        style={{ width: "100%", height: "100%" }}
        config={plotConfig}
      />
    </div>
  );
};

export default Plotly;
